import { AddOrUpdateSystemSettingParams } from '../Interfaces';

export function UpdateSystemSetting(this: any): AddOrUpdateSystemSettingParams {
	return {
		typeName: this.typeId === -1 ? this.newTypeName : this.typeName,
		name: this.name?.trim(),
		value: this.value?.trim(),
		description: this.description?.trim(),
		id: this.id,
		typeId: this.typeId,
		isSensitiveData: this.isSensitiveData ?? true,
	};
}
